export default __webpack_public_path__ + "static/media/walletconnect.f58515f4.svg";